import { z } from "incur";

export const AuthMethod = z.enum(["api_key", "oauth"]);
export type AuthMethod = z.infer<typeof AuthMethod>;

export const Identity = z.object({
	id: z.string().optional().describe("Account or user id"),
	title: z.string().optional().describe("Account display name or user name"),
	route: z.string().optional().describe("The account's public route"),
	email: z.string().optional().describe("User email address (oauth only)"),
});
export type Identity = z.infer<typeof Identity>;

// --- CTA / error shapes accepted by the run context (kept minimal & structural) ---
export type CtaCommand =
	| string
	| {
			command: string;
			description?: string | undefined;
			options?: Record<string, unknown> | undefined;
			args?: Record<string, unknown> | undefined;
	  };
export type CtaInput = {
	description?: string | undefined;
	commands: CtaCommand[];
};
export type ErrorInput = {
	code: string;
	message: string;
	cta?: CtaInput | undefined;
	exitCode?: number | undefined;
	retryable?: boolean | undefined;
};

export const Profile = z.object({
	name: z.string().describe("The local profile name"),
	method: AuthMethod,
	accountId: z.string().optional(),
	accountTitle: z.string().optional(),
	accountRoute: z.string().optional(),
	userId: z.string().optional(),
	userEmail: z.string().optional(),
	createdAt: z
		.string()
		.describe("ISO timestamp of when the profile was first created"),
});
export type Profile = z.infer<typeof Profile>;
